import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import PaymentsMilestones from "@/modules/Missions/components/PaymentMilestones/PaymentMilestones.vue"
import PricingProposal from "@/modules/Missions/components/PricingProposal/PricingProposal.vue"
import {
  MissionLifecycleFragmentFragment,
  StartPricingProposalDevelopmentMutation,
  StartPricingProposalDevelopmentMutationMutation,
  MissionContractPayment,
  MissionPricingProposal,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import SetupClientPaymentForm from "@/modules/Missions/components/Payment/SetupClientPaymentForm.vue"
import ContractMissionPaymentForm from "@/modules/Missions/components/form/ContractMissionPaymentForm.vue"
import { useMissionLifecycleContext } from "@/modules/Missions/hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'StaffBilling',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment
}



const { refetchQueries } = useMissionLifecycleContext()

const isSubmitting = ref(false)
const createPayment = ref(false)
const startPricingProposalDialog = ref(false)

const { mutate } = useMutation()
const { addSuccess, addError } = useNotification()

const pricingProposal = computed<MissionPricingProposal>(() => {
  return props.mission.missionProposal?.missionPricingProposal as MissionPricingProposal
})

const contractPayments = computed<MissionContractPayment[]>(() => {
  return props.mission.missionContract?.missionContractPayments as MissionContractPayment[]
})

const onStartPricingProposal = async () => {
  isSubmitting.value = true
  const result = await mutate<StartPricingProposalDevelopmentMutationMutation>({
    mutation: StartPricingProposalDevelopmentMutation,
    variables: {
      id: props.mission.prn,
    },
    refetchQueries,
    done: () => {
      isSubmitting.value = false
      startPricingProposalDialog.value = false
    },
  })
  if (result?.data?.startPricingProposalDevelopment.missionPricingProposal) {
    addSuccess("Pricing proposal development started")
  }
}

const onUpdatePayment = (payment: MissionContractPayment) => {
  activePayment.value = payment
  showPaymentModal.value = true
}

const activePayment = ref<MissionContractPayment | null>(null)
const showPaymentModal = ref(false)
const missionPaymentForm = ref(null)

const onClose = () => {
  ;(missionPaymentForm.value as any)?.resetForm()
  activePayment.value = null
  showPaymentModal.value = false
}

const onCreatePayment = () => {
  if (!props.mission.missionPricingProposal?.totalPrice?.amount) {
    addError(
      "You can not create client payments as the total price of the mission is unknown. Please ensure the scope is complete and pricing proposal has been created"
    )
    return
  }
  createPayment.value = true
}

return { __sfc: true,props, refetchQueries, isSubmitting, createPayment, startPricingProposalDialog, mutate, addSuccess, addError, pricingProposal, contractPayments, onStartPricingProposal, onUpdatePayment, activePayment, showPaymentModal, missionPaymentForm, onClose, onCreatePayment, Icon, PaymentsMilestones, PricingProposal, SetupClientPaymentForm, ContractMissionPaymentForm }
}

})